module.exports = __webpack_public_path__ + "img/13.dde69c92.png";